<template>
  <div id="enterprise-banner">
    <!-- 右键链接展示开始 -->
    <div v-if="rightSrc"
         style="width:100%;height:600px">
      <!--切换一开始-->
      <iframe style="width:100%;height:100%"
              :src="rightSrc"
              frameborder="0"></iframe>
      <!--切换一结束-->
    </div>
    <!-- 右键链接展示结束 -->
    <div v-else>
      <div class="left-box fl"
           @contextmenu.prevent="tabRight('0',$event)"
           @touchstart.prevent="touchstarts('0',$event)"
           @touchmove.prevent="touchmoves()"
           @touchend.prevent="touchends()">
        <ul id="banner-left"
            @mouseleave="showNext=false,ind = -1">
          <li :class="['first',index == ind?'curr':'']"
              v-for="(item,index) in content"
              :key="index"
              @mouseenter="showNexts(index)">
            <div class="name" @click="jump($event,item.id,'','',item.appId,item.name)">
              <a href="javascript:;">{{item.name}}</a>
            </div>
            <navbox :item="item" :index="index" :ind="ind" v-show="index == ind ? true : false"></navbox>
          </li>
        </ul>
      </div>
      <div class="center-box fl"
           @contextmenu.prevent="tabRight('1')"
           @touchstart="touchstarts('1',$event)"
           @touchmove="touchmoves()"
           @touchend="touchends()">
        <div class="top"
             v-if="pic.length">
          <div class="carousel_point swiper-pagination"> <span class="point curr"></span> <span class="point"></span> <span class="point"></span> </div>
          <div class="btn-left"></div>
          <div class="btn-right"></div>
          <!--轮播图片开始-->
          <div class="swiper-container"
               id="swiper-container1">
            <div class="photo swiper-wrapper">
              <a href="javascript:;"
                 class="swiper-slide"
                 v-for="(item,ind) in pic"
                 :key="ind">
                <img :src="item.pictureSrc"
                     alt="">
              </a>
            </div>
          </div>
          <!--轮播图片结束-->
        </div>
        <div v-else
             class="logo-icon">
          <!-- <div class="logo-icon-imtex">
            <img :src="require('../assets/image/images/default_media.png')"
                 alt="">
          </div> -->
        </div>
        <div class="clear"></div>
      </div>
      <div class="swiper-container center-r-box"
           id="swiper-container2"
           @contextmenu.prevent="tabRight('2')"
           @touchstart="touchstarts('2',$event)"
           @touchmove="touchmoves()"
           @touchend="touchends()">
        <div class="btn-left1"></div>
        <div class="btn-right1"></div>
        <div class="photo swiper-wrapper">
          <div class=" fl swiper-slide"
               v-for="(item,ind) in pictrue"
               :key="ind">
            <div :class="['center-top-box']">
              <img v-if="item[0]"
                   :src="item[0].pictureSrc"
                   alt="">
              <!-- <div v-else
                   class="logo-icon-imtex">
                <img :src="require('../assets/image/images/default_media.png')" />
              </div> -->
            </div>
            <div :class="['center-bottom-box']">
              <img v-if="item[1]"
                   :src="item[1].pictureSrc"
                   alt="">
              <!-- <div v-else
                   class="logo-icon-imtex">
                <img :src="require('../assets/image/images/default_media.png')" />
              </div> -->
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="bottom-box-left fl"
             @contextmenu.stop.prevent="">
          <img :src="require('../assets/image/images/activity_blue.png')"
           alt="">
          <img class="centers"
              :src="require('../assets/image/images/activity_shopping_cart.png')"
              alt="">
          <span class="texts one">好物推荐</span>
          <span class="texts two">探索智能生活</span>
          
        </div>
        <div class="bottom-box-right"
             @contextmenu.prevent="tabRight('3')"
             @touchstart="touchstarts('3',$event)"
             @touchmove="touchmoves()"
             @touchend="touchends()">
          <haowu :contentData="contentData"
                 :blockData="blockData"
                 :newBanner="true"
                 @arrowRight='getSeckill'
                 @emitContextMenuItem="leftRightMove"></haowu>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Bus from '../bus.js';
import haowu from './haowutuijian.vue'
import navbox from './navbox.vue'
export default {
  name: 'newBanner',
  components: {
    haowu,
    navbox
  },
  props: {
    blockData: Object,
    pictures: Array
  },
  data () {
    return {
      timeOutEvent: 0,
      nodeId1: '',
      nodeId2: '',
      nodeId3: '',
      ind: -1,
      pic: [],
      pictrue: [[]],
      content: [],
      Slidepictures: [],
      rightSrc: '',
      contentData: [],
      contentJsonArr: []
    }
  },
  watch: {
    "$store.state.rightSrc": function (val) {
      if (!this.rightSrc) {
        this.rightSrc = this.blockData.id == window.$floorflowId.id ? val : '';
      }
    }
  },
  mounted () {
    this.getData();
    var num = 5;
    if ( window.innerWidth <= 768) {
      num = 2;
    }
    this.getSeckill(1, num);
    window.launch = this.launch;
    window.retract = this.retract;
  },
  methods: {
    touchstarts (ind, ev) {
      var _this = this;
      // 长按事件触发
      clearTimeout(_this.timeOutEvent);
      _this.timeOutEvent = setTimeout(function () {
        _this.timeOutEvent = 0;
        _this.tabRight(ind, ev);
      }, 400);
      //长按400毫秒
      // e.preventDefault();
    },
    touchmoves () {
      clearTimeout(this.timeOutEvent);
      this.timeOutEvent = 0;
    },
    touchends (e) {
      clearTimeout(this.timeOutEvent);
      return false;
    },
    //左移右移
    leftRightMove (ind) {
      const item = this.contentData[ind];
      window.$nodeId = item.nodeId;
      var left = {}, center = {}, right = {};
      if (item && item.contentId) {
        center = {
          item: item,
          blockId: item.blockId,
          contentId: item.contentId,
          contentShowRowsSort: ind,
          standardJson: item.tags
        }
      }

      var rightLeft = {
        left: left,
        center: center,
        right: right
      }

      window.$rightLeft = rightLeft;
    },
    tabRight (ind, ev) {
      this.$store.commit('setFlowType', this.blockData.floorType);
      window.$changeFlowBlock = 'flow';
      window.$floorflowId = '';
      if (this.blockData.id) {
        window.$floorId = this.blockData.id;
        window.$floorflowId = this.blockData;
      }
      switch (ind) {
        case '0':
          Bus.$emit('windowRight', ev, 'floor');
          break;
        case '1':
          window.$nodeId = this.nodeId1;
          Bus.$emit('windowRight', ev, 'block');
          break;
        case '2':
          window.$nodeId = this.nodeId2;
          Bus.$emit('windowRight', ev, 'block');
          break;
        case '3':
          Bus.$emit('windowRight', ev, 'block');
          break;
      }
    },
    getSeckill(size,num){
      var _this = this;
      _this.$http
        .get("/zciid-deliverable/showPlatformStyle/flow/api/getConfigContentByAppId.json", {
          appId: _this.$appId,pageNum: size,pageSize: num,types: _this.blockData.flowEnName,floorEnName:_this.blockData.flowEnName
        }).then(res => {
          if (res.state == 1 && res.data.length) {
            var array = [];
            
            res.data.forEach((item) => {
              var tags = [], pictures = [], others = [], btns = [], contentId = '', blockId = '';
              contentId = item.contentId;
              blockId = item.blockId;
              item.standardJson.forEach((ele) => {
                if (ele.standardData && (ele.standardData.indexOf('.mp4') > 0 || ele.standardData.indexOf('.png') > 0 || ele.standardData.indexOf('.jpg') > 0 || ele.standardData.indexOf('.jpeg') > 0)) {
                  pictures.push(ele.standardData);
                } else {
                  others.push(ele);
                }
              })

              array.push({
                appId:item.appId,
                appName:item.appName,
                contentId: contentId,
                blockId: blockId,
                nodeId: item.nodeId,
                pictures: pictures,
                others: others,
                btns: btns,
                sign: item.sign,
                tags: item.standardJson,
                endTime: item.endTime,
                contentWzUrl:item.contentWzUrl,
                contentDsfWzUrl:item.contentDsfWzUrl,
                discountTypes: item.discountTypes,
                priceType: item.priceType,
                changeData: item.changeData,
                spellData: item.spellData,
                spellText: item.spellText,
                giveData: item.giveData,
                giveText: item.giveText,
                ordinaryPrice: item.ordinaryPrice,
                silverPrice: item.silverPrice,
                goldprice: item.goldprice,
                platinumPrice: item.platinumPrice,
                diamondsPrice: item.diamondsPrice,
                blackGoldprice: item.blackGoldprice,
                memberEndTime: item.memberEndTime
              })
            })
            _this.contentData.push(...array);
          }
        })
    },
    //跳转页面
    jump (e, id1, id2, id3,appIdStr,name) {
        e.preventDefault();
        e.stopPropagation();
        this.routerJump('push','flowList',{ appId: this.$appId, id1: id1 ? id1 : '', id2: id2 ? id2 : '', id3: id3 ? id3 : '',appIdStr: appIdStr},name);
    },
    //获取数据
    getData () {
      var _this = this;
      //获取左侧浮层
      _this.$http
        .get("/zciid-deliverable/api/showPlatform/content/getShelfDisplayByAppId.json", {
          appId: _this.$appId,
          flowId: _this.blockData.id
        }).then(res => {
          if (res.state == 1) {
            _this.content = res.data;
          }
        })
      //获取图片信息
      _this.$http
        .get("/zciid-deliverable/showPlatformStyle/flow/api/get/getContentByFlowId.json", {
          appId: _this.$appId,
          flowId: _this.blockData.id
        }).then(res => {
          if (res.state == 1) {
            if (res.data[0]) {
              if (res.data[0].contentJsonArr) {
                _this.filterData(res.data[0].contentJsonArr, _this.pic);
              }
              if (res.data[0].nodeId) {
                _this.nodeId1 = res.data[0].nodeId;
              }
            }
            if (res.data[1]) {
              if (res.data[1].contentJsonArr) {
                var arr = [];
                _this.filterData(res.data[1].contentJsonArr, arr);
                if (arr.length > 2) {
                  _this.pictrue = [];
                  for (var i = 0; i < arr.length; i += 2) {
                    _this.pictrue.push(arr.slice(i, i + 2));
                  }
                } else {
                  _this.pictrue = [[arr[0] ? arr[0] : '', arr[1] ? arr[1] : '']]
                }
              }
              if (res.data[1].nodeId) {
                _this.nodeId2 = res.data[1].nodeId;
              }
            }
            // if (res.data[2]) {
              // if (res.data[2].nodeId) {
              //   _this.nodeId3 = res.data[2].nodeId;
              // }
              // if (res.data[2].contentJsonArr && res.data[2].contentJsonArr.length) {
              //   _this.contentJsonArr = res.data[2].contentJsonArr;
              //   var array = [];
              //   res.data[2].contentJsonArr.forEach((item) => {
              //     var tags = [], pictures = [], others = [], btns = [], contentId = '', blockId = '';
              //     contentId = item.contentId;
              //     blockId = item.blockId;
              //     item.standardJson.forEach((ele) => {
              //       if (ele.standardData && (ele.standardData.indexOf('.mp4') > 0 || ele.standardData.indexOf('.png') > 0 || ele.standardData.indexOf('.jpg') > 0 || ele.standardData.indexOf('.jpeg') > 0)) {
              //         pictures.push(ele.standardData);
              //       } else {
              //         others.push(ele);
              //       }
              //     })
              //     array.push({
              //       contentId: contentId,
              //       blockId: blockId,
              //       nodeId: item.nodeId,
              //       pictures: pictures,
              //       others: others,
              //       btns: btns,
              //       sign: item.sign,
              //       tags: item.standardJson
              //     })
              //   })
              //   _this.contentData = array;
              // }
            // }
          }
        }).then(() => {
          _this.swiperNew();
        })
    },
    //筛选数据
    filterData (arr, item) {
      if (arr) {
        arr.forEach((ite) => {
          let aLink = 'javascript:;', pictureSrc = '';
          ite.standardJson.forEach((it) => {
            if (it.standardData != '' && (it.standardData.indexOf('.png') > -1 || it.standardData.indexOf('.jpg') > -1 || it.standardData.indexOf('.mp4') > -1)) {
              pictureSrc = it.standardData;
            }
            if (it.standardData != '' && it.standardName == "链接地址") {
              aLink = it.standardData;
            }
          })
          if (pictureSrc != '' && (pictureSrc.indexOf('.png') > -1 || pictureSrc.indexOf('.jpg') > -1 || pictureSrc.indexOf('.mp4') > -1)) {
            item.push({ aLink: aLink, pictureSrc: pictureSrc })
          }
        })
        return item;
      }
    },
    //鼠标移入展示下一级
    showNexts (ind) {
      this.ind = ind;
      
    },
    swiperNew () {
      var mySwiper = new Swiper('#swiper-container1', {
        autoplay: true,//可选选项，自动滑动
        navigation: {
          prevEl: '.btn-left',
          nextEl: '.btn-right'
        },
        effect: 'fade',
        fadeEffect: {
          crossFade: true
        },
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        }
      })
      var newSwiper = new Swiper('#swiper-container2', {
        navigation: {
          prevEl: '.btn-left1',
          nextEl: '.btn-right1'
        },
        effect: 'fade',
        fadeEffect: {
          crossFade: true
        },
        loop: true
      })
    }
  }
}
</script>
<style>
.logo-icon {
  width: 100%;
  height: 100%;
  position: relative;
  /* background-image: linear-gradient(30deg, #e1d5eb, #44b5ef); */
  background-color: #ededed;
}
.linear-gradient {
  position: relative;
  /* background-image: linear-gradient(30deg, #e1d5eb, #44b5ef); */
  background-color: #ededed;
}
.logo-icon-imtex {
  width: 70px;
  height: 70px;
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -35px 0 0 -35px;
}
#enterprise-banner img {
  width: 100%;
  height: 100%;
}
#enterprise-banner .left-box .first .nav-box .category .second .cont span{
  /* display: ruby; */
}
#enterprise-banner .left-box .first .nav-box .category .second .hide {
  display: none !important;
}
#enterprise-banner .packup ,#enterprise-banner .more{
  color: #0d78cf;
  cursor: pointer;
}
</style>
<style scoped>
@media screen   and (max-width: 768px) {
  .left-box,
  #swiper-container2,
  .bottom-box-left {
    display: none !important;
  }
  #enterprise-banner .bottom-box-right {
    left: 0 !important;
    padding: 0 10px;
    box-sizing: border-box;
  }
  #enterprise-banner {
    width: 100% !important;
  }
  #enterprise-banner .center-box {
    left: 0 !important;
    width: 100% !important;
    padding: 0 10px;
    box-sizing: border-box;
  }
  #enterprise-banner .center-box .top .swiper-slide img {
    width: 100% !important;
  }
  .bottom-box-right {
    width: 100% !important;
  }
}
.curr {
  background: #daeeff;
}
/* 滚动条 */
#banner-left {
  height: 340px;
  overflow: auto;
}
#banner-left::-webkit-scrollbar {
  width: 4px;
}
#banner-left::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.2);
}
#banner-left::-webkit-scrollbar-track {
  border-radius: 0;
  background: rgba(0, 0, 0, 0.1);
}
/* 主体 */
#enterprise-banner {
  width: 1200px;
  margin: 20px auto 0;
  height: 625px;
  position: relative;
}
/* 左侧内容 */
#enterprise-banner .left-box {
  width: 182px;
  height: 337px;
  background: #fff;
  border: 1px solid #ddd;
  position: relative;
  z-index: 11;
  padding: 11px 0;
}
#enterprise-banner .left-box .first {
  line-height: 28px;
  padding-left: 10px;
}
#enterprise-banner .left-box .first .name a {
  font-size: 14px;
  line-height: 30px;
}
#enterprise-banner .left-box .first .second a {
  font-size: 12px;
}
#enterprise-banner .left-box .first:last-child {
  border-bottom: 0 none;
}
/* #enterprise-banner .left-box .first:hover{ background: #daeeff;} */
#enterprise-banner .left-box .first:hover .name a {
  color: #333;
}
#enterprise-banner .left-box .first .name {
  background: url("https://520emv.com/jtzy/resources/01basis/fttid/control_library/webBlock/images//mall_class_banner/index_next.png")
    no-repeat right;
  margin-right: 10px;
}
#enterprise-banner .left-box .first .name a {
  padding: 0 5px;
  display: block;
  width: 140px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
#enterprise-banner .left-box .first .name i {
  color: #999;
}
#enterprise-banner .left-box .first:hover .name i {
  color: #fff;
}
#enterprise-banner .left-box .first:hover .name {
  background: url("https://520emv.com/jtzy/resources/01basis/fttid/control_library/webBlock/images//mall_class_banner/index_next_hover.png")
    no-repeat right;
}

/* 轮播图 */
#enterprise-banner .center-box {
  width: 798px;
  height: 360px;
  position: absolute;
  left: 194px;
}
#enterprise-banner .center-box .top {
  position: relative;
}
#enterprise-banner .center-box .top .carousel_point {
  bottom: 20px;
  left: 5%;
}

#enterprise-banner .center-box .top .swiper-slide img {
  width: 800px;
  height: 360px;
}
#enterprise-banner .center-box .top .btn-left {
  width: 25px;
  height: 35px;
  background: url("https://520emv.com/jtzy/resources/01basis/fttid/control_library/webBlock/images//mall_class_banner/btn_left.png");
  position: absolute;
  z-index: 2;
  left: 0;
  top: 162px;
}
#enterprise-banner .center-box .top .btn-left:hover {
  background: url("https://520emv.com/jtzy/resources/01basis/fttid/control_library/webBlock/images//mall_class_banner/btn_left_c.png");
}
#enterprise-banner .center-box .top .btn-right {
  width: 25px;
  height: 35px;
  background: url("https://520emv.com/jtzy/resources/01basis/fttid/control_library/webBlock/images//mall_class_banner/btn_right.png");
  position: absolute;
  z-index: 2;
  right: 0;
  top: 162px;
}
#enterprise-banner .center-box .top .btn-right:hover {
  background: url("https://520emv.com/jtzy/resources/01basis/fttid/control_library/webBlock/images//mall_class_banner/btn_right_c.png");
}

/* 右侧图片 */
#enterprise-banner .center-r-box {
  width: 190px;
  height: 360px;
  position: absolute;
  left: 1004px;
}
#enterprise-banner .center-r-box .center-top-box {
  width: 190px;
  height: 175px;
  margin-bottom: 10px;
  background-color: #ededed;
}
#enterprise-banner .center-r-box .center-bottom-box {
  width: 190px;
  height: 175px;
  background-color: #ededed;
}
#enterprise-banner .center-r-box .btn-left1 {
  width: 25px;
  height: 35px;
  background: url("https://520emv.com/jtzy/resources/01basis/fttid/control_library/webBlock/images//mall_class_banner/btn_left.png");
  position: absolute;
  z-index: 2;
  left: 0;
  top: 162px;
}
#enterprise-banner .center-r-box .btn-left1:hover {
  background: url("https://520emv.com/jtzy/resources/01basis/fttid/control_library/webBlock/images//mall_class_banner/btn_left_c.png");
}
#enterprise-banner .center-r-box .btn-right1 {
  width: 25px;
  height: 35px;
  background: url("https://520emv.com/jtzy/resources/01basis/fttid/control_library/webBlock/images//mall_class_banner/btn_right.png");
  position: absolute;
  z-index: 2;
  right: 0;
  top: 162px;
}
#enterprise-banner .center-r-box .btn-right1:hover {
  background: url("https://520emv.com/jtzy/resources/01basis/fttid/control_library/webBlock/images//mall_class_banner/btn_right_c.png");
}

/* 下方好物推荐 */
#enterprise-banner .bottom-box-left {
  position: absolute;
  top: 370px;
  display: flex;
  justify-content: center;
  height: 252px;
  width: 184px;
}
#enterprise-banner .bottom-box-left .texts {
  position: absolute;
  letter-spacing: 1px;
  color: #fff;
}
#enterprise-banner .bottom-box-left .texts.one{
  font-size: 26px;
  font-weight: bold;
  top: 45px;
}
#enterprise-banner .bottom-box-left .texts.two{
  font-size: 20px;
  top: 85px;
}
#enterprise-banner .bottom-box-left .centers {
  position: absolute;
  left: 65px;
  top: 135px;
  width: 50px;
  height: 50px;
}
#enterprise-banner .bottom-box-right {
  position: absolute;
  top: 370px;
  left: 194px;
  height: 252px;
  width: 1000px;
}
</style>
<style>
#enterprise-banner .center-box .top .carousel_point .swiper-pagination-bullet {
  background: #fff;
  opacity: 0.3;
  width: 10px;
  height: 10px;
  margin-right: 6px;
}
#enterprise-banner
  .center-box
  .top
  .carousel_point
  .swiper-pagination-bullet.swiper-pagination-bullet-active {
  background: #fff;
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/newBanner.vue